import { ca } from '@cian/analytics';

import { type IResidentialComplex } from 'shared/types/residentials';
import { createDeveloperProduct } from 'shared/utils/analytics';

/**
 * @description Событие: клик по карточке ЖК в блоке проектов ПИК.
 */
export function trackPikProjectsJkCardClick(complex: IResidentialComplex, index: number): void {
  ca('eventSite', {
    action: 'click_pik_projects_jk_card',
    category: 'Promo',
    label: 'pik_projects_jk_card',
    name: 'oldevent',
    products: [
      createDeveloperProduct({
        extra: {
          items: [
            {
              id: complex.id,
              offerType: 'newbuilding_id',
              position: index,
            },
          ],
        },
      }),
    ],
  });
}
